<template>
    <div class="dealWithBox">
        <div class="detailedInformation">
            <div class="deatlisName">
                <h4>合同详情</h4>
                <p style="border: 1px solid rgb(59, 99, 246);"></p>
            </div>
            <div class="deatlisContent">
                <div class="caseStatusBox">
                    <div class="caseStatus">
                        <p>合同名称:</p>
                        <span>{{caseContent.doc_title}}</span>
                    </div>
                    <div class="caseNo">
                        <p>合同编号:</p>
                        <span>{{caseContent.contract_sn}}</span>
                    </div>
                    <div class="registerTime">
                        <p>发起方:</p>
                        <span>{{caseContent.faqi_fang}}</span>
                    </div>
                </div>
                <div class="reasonBox">
                    <div class="reason">
                        <p>发起时间:</p>
                        <span>{{caseContent.create_time}}</span>
                    </div>
                    <div class="contractType">
                        <p>截止时间:</p>
                        <span>{{caseContent.expire_time}}</span>
                    </div>
                    <div class="money">
                        <p>合同状态:</p>
                        <span style="color: red">{{caseContent.status_desc}}</span>
                    </div>
                </div>
                <div class="reasonBox" v-if="caseContent.err_info">
                    <div class="err">
                        <p>错误信息：</p>
                        <span style="color: #ff0000">{{caseContent.err_info}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { failureDetails } from '../../../api/contract';

    export default {
        name: 'loseDetail',
        data(){
            return{
                caseContent:'',
                data:''
            }
        },
        created() {
            failureDetails({signer_list_id:this.$route.query.id}).then(res=>{
                if (res.code==200){
                    this.caseContent=res.data
                    this.data=res.data.signers
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .dealWithBox {
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }

    p {
        color: #9f9fa2;
        margin-right: 10px;
    }

    span {
        color: #535354;
    }

    .deatlisName > h4 {
        color: #3b63f6;
        width: 100px;
        text-align: center;
        margin-bottom: 10px;
    }

    .deatlisName > p {
        width: 100px;
    }

    /*标题下边内容*/
    .deatlisContent {
        padding: 20px 10px;
    }

    .caseStatus,
    .caseNo,
    .registerTime{
        display: flex;
        width: 30%;
        align-items: flex-end;
    }

    .caseStatusBox {
        display: flex;
        padding: 10px 0px;
    }
    /*申请人*/

    .reasonBox{
        display: flex;
        padding: 10px 0px;
    }

    .reason,
    .contractType,
    .money,
    .err{
        display: flex;
        width: 30%;
        align-items: flex-end;
    }

    .customize {
        margin-top: 30px;
        background-color: #3b63f6;
        color: #FFFFFF;
    }
    .View{
        background-color: #3e62f6;
        color: #fff;
    }
</style>
